import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _51589259 = () => interopDefault(import('..\\pages\\about\\index.vue' /* webpackChunkName: "pages/about/index" */))
const _2a62908e = () => interopDefault(import('..\\pages\\business\\index.vue' /* webpackChunkName: "pages/business/index" */))
const _45a1cc88 = () => interopDefault(import('..\\pages\\cahandle\\index.vue' /* webpackChunkName: "pages/cahandle/index" */))
const _89be8a74 = () => interopDefault(import('..\\pages\\download\\index.vue' /* webpackChunkName: "pages/download/index" */))
const _9e8460ec = () => interopDefault(import('..\\pages\\guide\\index.vue' /* webpackChunkName: "pages/guide/index" */))
const _278504fd = () => interopDefault(import('..\\pages\\login\\index.vue' /* webpackChunkName: "pages/login/index" */))
const _12d304ca = () => interopDefault(import('..\\pages\\news\\index.vue' /* webpackChunkName: "pages/news/index" */))
const _433ff46a = () => interopDefault(import('..\\pages\\register\\index.vue' /* webpackChunkName: "pages/register/index" */))
const _8b7ade76 = () => interopDefault(import('..\\pages\\business\\detail.vue' /* webpackChunkName: "pages/business/detail" */))
const _0d417189 = () => interopDefault(import('..\\pages\\business\\detail-sd.vue' /* webpackChunkName: "pages/business/detail-sd" */))
const _4b016300 = () => interopDefault(import('..\\pages\\info\\list.vue' /* webpackChunkName: "pages/info/list" */))
const _748c4558 = () => interopDefault(import('..\\pages\\news\\detail.vue' /* webpackChunkName: "pages/news/detail" */))
const _fa82aaa8 = () => interopDefault(import('..\\pages\\register\\nmindex.vue' /* webpackChunkName: "pages/register/nmindex" */))
const _908cb2ce = () => interopDefault(import('..\\pages\\register\\otherindex.vue' /* webpackChunkName: "pages/register/otherindex" */))
const _322a519f = () => interopDefault(import('..\\pages\\business\\components\\file-download.vue' /* webpackChunkName: "pages/business/components/file-download" */))
const _735c2103 = () => interopDefault(import('..\\pages\\business\\components\\link-paper.vue' /* webpackChunkName: "pages/business/components/link-paper" */))
const _74ceaef8 = () => interopDefault(import('..\\pages\\business\\components\\search-bar.vue' /* webpackChunkName: "pages/business/components/search-bar" */))
const _21f09f75 = () => interopDefault(import('..\\pages\\business\\components\\table-hxrgs.vue' /* webpackChunkName: "pages/business/components/table-hxrgs" */))
const _07aa925e = () => interopDefault(import('..\\pages\\register\\components\\btn-yzm.vue' /* webpackChunkName: "pages/register/components/btn-yzm" */))
const _70227a46 = () => interopDefault(import('..\\pages\\register\\components\\captcha.vue' /* webpackChunkName: "pages/register/components/captcha" */))
const _5610d1e8 = () => interopDefault(import('..\\pages\\register\\components\\input-yzm.vue' /* webpackChunkName: "pages/register/components/input-yzm" */))
const _7b45803b = () => interopDefault(import('..\\pages\\register\\components\\tos.vue' /* webpackChunkName: "pages/register/components/tos" */))
const _210770ce = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _6f98be41 = () => interopDefault(import('..\\pages\\index\\sections\\about.vue' /* webpackChunkName: "pages/index/sections/about" */))
const _a83937c2 = () => interopDefault(import('..\\pages\\index\\sections\\ad.vue' /* webpackChunkName: "pages/index/sections/ad" */))
const _1947ceb0 = () => interopDefault(import('..\\pages\\index\\sections\\banner.vue' /* webpackChunkName: "pages/index/sections/banner" */))
const _3fe24204 = () => interopDefault(import('..\\pages\\index\\sections\\banner-login.vue' /* webpackChunkName: "pages/index/sections/banner-login" */))
const _7b5d463c = () => interopDefault(import('..\\pages\\index\\sections\\business.vue' /* webpackChunkName: "pages/index/sections/business" */))
const _011e1e97 = () => interopDefault(import('..\\pages\\index\\sections\\enters.vue' /* webpackChunkName: "pages/index/sections/enters" */))
const _3837e1cf = () => interopDefault(import('..\\pages\\index\\sections\\news.vue' /* webpackChunkName: "pages/index/sections/news" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _51589259,
    alias: "/about/index.html",
    name: "about"
  }, {
    path: "/business",
    component: _2a62908e,
    alias: "/business/index.html",
    name: "business"
  }, {
    path: "/cahandle",
    component: _45a1cc88,
    alias: "/cahandle/index.html",
    name: "cahandle"
  }, {
    path: "/download",
    component: _89be8a74,
    alias: "/download/index.html",
    name: "download"
  }, {
    path: "/guide",
    component: _9e8460ec,
    alias: "/guide/index.html",
    name: "guide"
  }, {
    path: "/login",
    component: _278504fd,
    alias: "/login/index.html",
    name: "login"
  }, {
    path: "/news",
    component: _12d304ca,
    alias: "/news/index.html",
    name: "news"
  }, {
    path: "/register",
    component: _433ff46a,
    alias: "/register/index.html",
    name: "register"
  }, {
    path: "/business/detail",
    component: _8b7ade76,
    alias: "/business/detail/index.html",
    name: "business-detail"
  }, {
    path: "/business/detail-sd",
    component: _0d417189,
    alias: "/business/detail-sd/index.html",
    name: "business-detail-sd"
  }, {
    path: "/info/list",
    component: _4b016300,
    alias: "/info/list/index.html",
    name: "info-list"
  }, {
    path: "/news/detail",
    component: _748c4558,
    alias: "/news/detail/index.html",
    name: "news-detail"
  }, {
    path: "/register/nmindex",
    component: _fa82aaa8,
    alias: "/register/nmindex/index.html",
    name: "register-nmindex"
  }, {
    path: "/register/otherindex",
    component: _908cb2ce,
    alias: "/register/otherindex/index.html",
    name: "register-otherindex"
  }, {
    path: "/business/components/file-download",
    component: _322a519f,
    alias: "/business/components/file-download/index.html",
    name: "business-components-file-download"
  }, {
    path: "/business/components/link-paper",
    component: _735c2103,
    alias: "/business/components/link-paper/index.html",
    name: "business-components-link-paper"
  }, {
    path: "/business/components/search-bar",
    component: _74ceaef8,
    alias: "/business/components/search-bar/index.html",
    name: "business-components-search-bar"
  }, {
    path: "/business/components/table-hxrgs",
    component: _21f09f75,
    alias: "/business/components/table-hxrgs/index.html",
    name: "business-components-table-hxrgs"
  }, {
    path: "/register/components/btn-yzm",
    component: _07aa925e,
    alias: "/register/components/btn-yzm/index.html",
    name: "register-components-btn-yzm"
  }, {
    path: "/register/components/captcha",
    component: _70227a46,
    alias: "/register/components/captcha/index.html",
    name: "register-components-captcha"
  }, {
    path: "/register/components/input-yzm",
    component: _5610d1e8,
    alias: "/register/components/input-yzm/index.html",
    name: "register-components-input-yzm"
  }, {
    path: "/register/components/tos",
    component: _7b45803b,
    alias: "/register/components/tos/index.html",
    name: "register-components-tos"
  }, {
    path: "/",
    component: _210770ce,
    alias: "/index.html",
    name: "index",
    children: [{
      path: "sections/about",
      component: _6f98be41,
      name: "index-sections-about"
    }, {
      path: "sections/ad",
      component: _a83937c2,
      name: "index-sections-ad"
    }, {
      path: "sections/banner",
      component: _1947ceb0,
      name: "index-sections-banner"
    }, {
      path: "sections/banner-login",
      component: _3fe24204,
      name: "index-sections-banner-login"
    }, {
      path: "sections/business",
      component: _7b5d463c,
      name: "index-sections-business"
    }, {
      path: "sections/enters",
      component: _011e1e97,
      name: "index-sections-enters"
    }, {
      path: "sections/news",
      component: _3837e1cf,
      name: "index-sections-news"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
